import css from "./StaticContent.module.css";
import blogData from "../../containers/BlogPage/blogs.json";
import NamedLink from "../NamedLink/NamedLink";

export default function UniversalPetCare() {
  const blogs = blogData.slice(0, 4);

  return (
    <div className={css.wrapper}>
      <section className={css.section}>
        <h1 className={css.headingPrimary}>
          Purfurry – Trusted Pet Care, Delivered by Pet Experts Near You
        </h1>

        <div className={css.section1Wrapper}>
          <div>
            <p className={css.text}>
              Purfurry helps pet parents discover and book trusted pet care
              services including dog boarding, cat boarding, home-based boarding,
              pet hostels, daycare, and grooming — all verified for quality,
              safety, and reliability.
            </p>

            <p className={css.text}>
              Whether you’re looking for short-term pet daycare, overnight dog or
              cat boarding, long-term stays, or professional grooming services,
              Purfurry makes it simple to find the right option for your dog or
              cat. Every provider on the platform is carefully reviewed for
              hygiene standards, safety protocols, and compassionate handling.
            </p>
          </div>

          <img
            src="/static/searchpage/582534123_17915740467220602_.jpg"
            alt=""
          />
        </div>

        <p className={css.text}>
          All partners on Purfurry are passionate pet lovers who deeply care for
          dogs, cats, and other companion animals. From routine grooming to
          premium boarding experiences, Purfurry ensures your pet enjoys a
          comfortable, social, and healthy stay.
        </p>

        <h2 className={css.headingSecondary}>
          Why Pet Parents Choose Purfurry
        </h2>

        <ul className={css.list}>
          <li>
            <b>Smart Search:</b> Easily explore and compare dog boarding, cat
            boarding, grooming, and daycare options by service type and
            preferences.
          </li>
          <li>
            <b>Fast & Transparent Booking:</b> Book pet care services in just a
            few clicks.
          </li>
          <li>
            <b>Verified Partners:</b> Every boarder, groomer, and provider is
            reviewed for quality and care standards.
          </li>
          <li>
            <b>All-in-One Platform:</b> Access boarding, daycare, and grooming
            under one trusted platform.
          </li>
          <li>
            <b>Reliable Support:</b> Assistance available throughout your
            booking journey.
          </li>
        </ul>

        <p className={css.text}>
          With Purfurry, finding dependable pet care is simple, transparent, and
          stress-free.
        </p>
      </section>

      <div className={css.divider}></div>

      <section className={css.section}>
        <h2 className={css.headingSecondary}>How Purfurry Works</h2>

        <ul className={css.list}>
          <li>
            <b>Search Pet Care Services:</b> Browse verified boarding homes, pet
            hostels, groomers, and daycare providers based on your needs.
          </li>
          <li>
            <b>Book with Confidence:</b> Choose a provider that fits your pet’s
            routine, temperament, and schedule.
          </li>
          <li>
            <b>Flexible Pick-Up & Drop-Off:</b> Coordinate convenient pick-up and
            drop-off options where available.
          </li>
          <li>
            <b>Cage-Free & Supervised Care:</b> Many providers offer structured
            playtime, socialization, and mental stimulation.
          </li>
          <li>
            <b>Regular Updates:</b> Receive updates on meals, grooming sessions,
            and overall well-being.
          </li>
        </ul>
      </section>

      <div className={css.divider}></div>

      <section className={css.section}>
        <h2 className={css.headingSecondary}>Boarding Guidelines</h2>

        <ul className={css.list}>
          <li>Pets must be socialized, vaccinated, and healthy.</li>
          <li>
            Pet parents should provide medications and special instructions in
            advance.
          </li>
          <li>
            Providers follow hygiene, feeding, and monitoring protocols.
          </li>
          <li>
            Pets with aggressive behavior or special medical needs may require
            customized care.
          </li>
          <li>
            Premium boarding options may be available for private handling.
          </li>
        </ul>

        <div className={css.howWrapper}>
          <h2 className={css.headingSecondary}>
            Book Trusted Pet Boarding & Daycare
          </h2>
          <p className={css.howSubtitle}>
            Home Boarders and Expert Care, Just a Few Clicks Away
          </p>

          <div className={css.howGrid}>
            <div className={css.howCard}>
              <h3 className={css.howCardTitle}>1. Search</h3>
              <p className={css.howCardText}>
                Find verified boarding and daycare services tailored to your
                pet’s comfort and routine.
              </p>
            </div>

            <div className={css.howCard}>
              <h3 className={css.howCardTitle}>2. Book & Pay</h3>
              <p className={css.howCardText}>
                Book instantly and pay securely for trusted pet care services.
              </p>
            </div>

            <div className={css.howCard}>
              <h3 className={css.howCardTitle}>3. Relax</h3>
              <p className={css.howCardText}>
                Enjoy peace of mind knowing your pet is cared for by verified
                professionals.
              </p>
            </div>
          </div>
        </div>

        <h2 className={css.headingSecondary}>Cage-Free & Social Play</h2>

        <ul className={css.list}>
          <li>Supervised, cage-free environments where applicable.</li>
          <li>Structured socialization for positive interactions.</li>
          <li>Active monitoring of health, safety, and behavior.</li>
          <li>Special arrangements available for pets needing separate care.</li>
        </ul>

        <h2 className={css.headingSecondary}>Grooming & Food Services</h2>

        <ul className={css.list}>
          <li>
            Grooming may include bathing, nail trimming, ear cleaning, and coat
            care.
          </li>
          <li>
            Special diets or medications should be communicated in advance.
          </li>
          <li>Clean feeding areas and proper hydration are ensured.</li>
        </ul>

        <h2 className={css.headingSecondary}>Health & Safety</h2>

        <ul className={css.list}>
          <li>Up-to-date vaccinations are required.</li>
          <li>
            Microchipping and pet insurance are strongly recommended.
          </li>
        </ul>

        <h2 className={css.headingSecondary}>
          Pick-Up & Drop-Off Guidelines
        </h2>

        <ul className={css.list}>
          <li>Timings are pre-coordinated to reduce stress.</li>
          <li>Smooth handovers ensure better pet comfort.</li>
          <li>
            Only authorized individuals should handle pets during transfers.
          </li>
        </ul>
      </section>

      <div className={css.divider}></div>

      <section className={css.section}>
        <h2 className={css.headingSecondary}>
          Become a Purfurry Care Provider — Earn Extra Income
        </h2>

        <p className={css.text}>
          Purfurry welcomes responsible pet lovers, home boarders, groomers,
          daycare providers, and pet hostel owners to join its trusted network.
          We help providers gain visibility without marketing effort.
        </p>

        <ul className={css.list}>
          <li>Dog and cat boarding</li>
          <li>Pet daycare</li>
          <li>Dog, cat, and pet grooming</li>
        </ul>

        <div className={css.joinWrapper}>
          <img
            src="/static/searchpage/8e25c8f14b44accb6faf81e50b05f8207caf6f.jpg"
            className={css.joinImg}
            alt=""
          />
          <div className={css.joinContent}>
            <h2 className={css.headingSecondary}>
              Love pets? Join as a provider today!
            </h2>

            <p className={css.joinSubtitle}>
              Get discovered. Get booked. Get paid. Join Purfurry — India’s
              trusted pet care network.
            </p>

            <button className={css.joinButton}>Join us now</button>
          </div>
        </div>

        <h3 className={css.headingSecondary}>For Dog Trainers</h3>
        <p className={css.text}>
          A dedicated offering for dog trainers is currently in development.
        </p>
      </section>

      <div className={css.divider}></div>

      <section className={css.section}>
        <h2 className={css.headingPrimary}>FAQs</h2>

        <div className={css.faqItem}>
          <div className={css.faqQuestion}>
            What services are available on Purfurry?
          </div>
          <div className={css.faqAnswer}>
            Verified dog boarding, cat boarding, home boarding, pet hostels,
            daycare, grooming, hygiene care, and related services.
          </div>
        </div>

        <div className={css.faqItem}>
          <div className={css.faqQuestion}>
            How do I book pet care services?
          </div>
          <div className={css.faqAnswer}>
            Search for the service, compare verified providers, review pricing
            and availability, and book in a few clicks.
          </div>
        </div>

        <div className={css.faqItem}>
          <div className={css.faqQuestion}>
            Why should pet parents use Purfurry?
          </div>
          <div className={css.faqAnswer}>
            Transparent pricing, verified providers, real reviews, and a smooth
            booking experience — all focused on your pet’s well-being.
          </div>
        </div>
      </section>

      <div className={css.divider}></div>

      <div className={css.blogWrapper}>
        <h2 className={css.blogTitle}>Discover Expert Pet Tips & Guides</h2>

        <div className={css.blogGrid}>
          {blogs.map(blog => {
            const linkProps = blog.cmspage
              ? { name: "CMSPage", params: { pageId: blog.slug } }
              : {};

            return (
              <NamedLink
                key={blog.slug}
                {...linkProps}
                className={css.blogCard}
              >
                <img
                  src={blog.coverImage}
                  alt={blog.title}
                  className={css.blogImage}
                />
                <div className={css.blogCardBody}>
                  <h3 className={css.blogCardTitle}>{blog.title}</h3>
                  <p className={css.blogMeta}>
                    By {blog.author} • {blog.date}
                  </p>
                </div>
              </NamedLink>
            );
          })}
        </div>

        <div className={css.showMoreWrapper}>
          <NamedLink
            name="BlogsLandingPage"
            className={css.showMoreBtn}
          >
            Show More Blogs →
          </NamedLink>
        </div>
      </div>
    </div>
  );
}
